const areas = [
  { name: 'Hayden, ID', primary: true },
  { name: 'Post Falls', primary: true },
  { name: "Coeur d'Alene", primary: true },
  { name: 'Spokane, WA', primary: true },
  { name: 'Rathdrum', primary: false },
  { name: 'Athol', primary: false },
  { name: 'Surrounding Areas', primary: false },
];

const services = [
  'Custom Landscaping',
  'Hardscaping & Patios',
  'Retaining Walls',
  'Turf Installation',
  'French Drains',
  'Snow Removal',
  'Sprinkler Systems',
  'Seasonal Clean-Up',
];

export default function ServiceAreas() {
  return (
    <section className="w-full">
      {/* Header band */}
      <div className="bg-[#111111] py-14 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-8 bg-gold"></div>
              <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-gold">Service Coverage</span>
            </div>
            <h2 className="font-serif text-white font-semibold" style={{ fontSize: 'clamp(2rem, 3.5vw, 2.8rem)' }}>
              Serving North Idaho &amp; Eastern Washington
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {areas.map((a) => (
              <span
                key={a.name}
                className={`font-sans text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap ${
                  a.primary ? 'bg-gold text-forest-deep' : 'bg-white/8 text-white/55 border border-white/10'
                }`}
              >
                {a.name}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Map + Info — full-bleed */}
      <div className="grid grid-cols-1 lg:grid-cols-3" style={{ minHeight: '560px' }}>
        <div className="lg:col-span-2 h-72 lg:h-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85648.47!2d-116.8!3d47.77!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5361c064d62d06bf%3A0xf3c8b15e4ac6639d!2sCQC%20Landscaping!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
            width="100%" height="100%" style={{ border: 0, display: 'block', minHeight: '300px' }}
            allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            title="CQC Landscaping Service Area"
          ></iframe>
        </div>

        <div className="bg-forest flex flex-col justify-between p-10 lg:p-12">
          <div>
            <p className="font-sans text-[9px] tracking-[0.25em] uppercase text-gold mb-6">Services in All Areas</p>
            <ul className="space-y-3.5">
              {services.map((s) => (
                <li key={s} className="flex items-center gap-3 font-sans text-sm text-white/65">
                  <i className="ri-checkbox-circle-fill text-gold shrink-0"></i>
                  {s}
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-3 mt-10 pt-8 border-t border-white/10">
            <a href="https://www.google.com/maps/place/CQC+Landscaping/@47.7693454,-117.1510443,10z" target="_blank" rel="noreferrer noopener"
              className="w-full flex items-center justify-center gap-2 bg-white/8 hover:bg-white/14 text-white text-sm font-semibold rounded-xl py-3.5 transition-colors cursor-pointer border border-white/10 whitespace-nowrap">
              <i className="ri-external-link-line text-gold"></i> View on Google Maps
            </a>
            <a href="tel:+12086596067"
              className="w-full flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-forest-deep font-bold text-sm rounded-xl py-3.5 transition-all cursor-pointer shadow-lg shadow-gold/20 whitespace-nowrap">
              <i className="ri-phone-fill"></i> (208) 659-6067
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
